/** @format */

export const API = {
  // eslint-disable-next-line max-len
  getEventHistoryList: '/monitor/?Action=DescribeEventAlertHistoryList&Version=2021-01-01', // 获取事件告警历史
  getTacticsHistoryList: '/monitor/?Action=DescribeAlertHistories&Version=2021-01-01', // 获取阈值告警策略列表
  getTacticsHistorydashboard: '/monitorapi/v2/dashboard/querydata?parallel' // 阈值告警监控图表
}

export default API
